import * as lookups from "./lookups";
import * as user from "./user";
import * as projects from "./projects";
import * as earnings from "./earnings";
import * as rates from "./rates";
import * as invoices from "./invoices";

export const actions = {
  ...lookups,
  ...user,
  ...projects,
  ...earnings,
  ...rates,
  ...invoices,
};
